import { IFieldContainer, IFieldDefinition, IFormConfig } from 'app/interfaces';
import { fieldsMap } from '../fields';

const formFields: (IFieldContainer|IFieldDefinition)[] = [
	fieldsMap.get('type_vat_code'),
	{
		config: {
			flexLayout: 'row'
		},
		fields: [
			fieldsMap.get('source_code_taxation'),
			fieldsMap.get('vat_rate')
		]
	},
	{
		config: {
			flexLayout: 'row'
		},
		fields: [
			fieldsMap.get('target_code_vat')
		]
	},
	fieldsMap.get('notes')
];

const config: IFormConfig = {
	title: 'Crea mappatura fiscalità',
	editTitle: 'Modifica mappatura fiscalità',
	fields: formFields
};

export default config;
